import React from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  layout: {
    display: 'flex',
    height: '100%',
    flex: 1,
    alignItems: 'stretch',
    overflow: 'hidden',
    position: 'relative',
    [theme.media.mobile]: {
      height: 'auto',
    },
  },
  layoutPaneOpenMobile: {
    [theme.media.mobile]: {
      height: '100%',
    },
  },
  mainContent: {
    flex: 1,
    overflow: 'auto',
    position: 'relative',
    [theme.media.mobile]: {
      overflow: 'unset',
    },
  },
  mainContentNoScroll: {
    overflow: 'hidden',
  },
  mainClose: {
    [theme.media.mobile]: {
      display: 'none',
    },
  },
  pane: {
    position: 'relative',

    transition: 'width .3s, transform .2s ease-in',
    transform: 'translateX(400px)',
    background: 'white',

    width: 0,
    maxWidth: '100vw',

    [theme.media.tablet]: {
      width: 384,
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      boxShadow: theme.boxShadow.base,
      zIndex: 1,
    },
    [theme.media.mobile]: {
      width: '100%',
      height: '100%',
      transform: `translateX(${theme.breackPoints.mobile}px)`,
      zIndex: 200,
    },
  },
  paneOpened: {
    transform: 'translateX(0)',
    width: 384,
    height: '100%',
    [theme.media.mobile]: {
      width: '100%',
    },
  },
}));

type Props = {
  children: React.ReactNode;
  pane: (params: {
    isOpen: boolean;
    onRequestClose: () => any;
  }) => React.ReactNode;
  isOpen: boolean;
  onRequestClose: () => any;
  noScroll?: boolean;
  mainContentClassName?: string;
  paneClassName?: string;
  disablePaneOnClose?: boolean;
};

export const WithRightClosablePane = (props: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div
      className={classnames(classes.layout, {
        [classes.layoutPaneOpenMobile]: props.isOpen,
      })}
    >
      <div
        className={classnames(
          classes.mainContent,
          {
            [classes.mainContentNoScroll]: props.noScroll,
            [classes.mainClose]: props.isOpen,
          },
          props.mainContentClassName,
        )}
      >
        {props.children}
      </div>
      <div
        className={classnames(
          classes.pane,
          {
            [classes.paneOpened]: props.isOpen,
          },
          props.paneClassName,
        )}
      >
        {(props.disablePaneOnClose ? props.isOpen : true) &&
          props.pane({
            onRequestClose: props.onRequestClose,
            isOpen: props.isOpen,
          })}
      </div>
    </div>
  );
};
